import React, { useEffect, useState } from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'

import Button from '@atoms/Button'

import { Wrapper, Text, Actions } from './styles.js'

// Keep in sync with the consent script in gatsby-ssr.js
export const CONSENT_KEY = 'mola-cookie-consent'

const readConsent = () => {
  try {
    return window.localStorage.getItem(CONSENT_KEY)
  } catch (e) {
    return null
  }
}

const saveConsent = value => {
  try {
    window.localStorage.setItem(CONSENT_KEY, value)
  } catch (e) {}
}

// Google Consent Mode v2 - GTM / GA read this before sending anything
const updateConsent = value => {
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  })
  window.dataLayer.push({ event: 'cookie_consent_update', consent: value })
}

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)
  const [shown, setShown] = useState(false)

  useEffect(() => {
    // Rendered only in the browser, and only until the visitor decides
    if (!readConsent()) {
      setVisible(true)
      // After the hero intro animation (it finishes around 4.2s)
      const timer = setTimeout(() => setShown(true), 5000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleChoice = value => {
    saveConsent(value)
    updateConsent(value)
    setShown(false)
    setTimeout(() => setVisible(false), 600)
  }

  if (!visible) return null

  return (
    <Wrapper active={shown} role="dialog" aria-label="Cookie consent">
      <Text>
        We use cookies to understand how visitors use our site and to improve
        it. You can accept or reject analytics cookies.{' '}
        <TransitionLink
          to="/privacy"
          title="Privacy Policy"
          exit={{
            length: 1.2,
            trigger: () => {
              localStorage.setItem('color', '#4100F5')
            },
          }}
          entry={{
            delay: 1.2,
          }}
        >
          Privacy Policy
        </TransitionLink>
      </Text>
      <Actions>
        <Button ghost smallPaddings onClick={() => handleChoice('denied')}>
          Reject
        </Button>
        <Button primary smallPaddings onClick={() => handleChoice('granted')}>
          Accept
        </Button>
      </Actions>
    </Wrapper>
  )
}

export default CookieBanner
